import React, {Component} from 'react';
import {Redirect} from 'react-router-dom'
import {Table,message,PageHeader,Button,Modal,Space} from 'antd';
import reqwest from 'reqwest'
import {Header} from '../Header.jsx'
import {Footer} from '../Footer.jsx'
import {CheckLogin} from '../Common.jsx'
import { ExclamationCircleOutlined} from '@ant-design/icons';
// import BuildTitle from '../BuildTitle.jsx'


export class Apply extends Component {
	constructor(props) {
	    super(props);
		let token = '';
		let user_name = '';
		let role = '';
		let check_result = CheckLogin()
		if (check_result !== false){
			token = check_result.Authorization
	    	user_name = check_result.user_name
	    	role = check_result.role;
		}
		this.state = {
			...props,
			'token' : token,
			'user_name': user_name,
			'role': role,
			'redirect' : '',
			'list' : [],
			'loading': true,
			'pagination': {
				'pageSize': 20,
				'current' : 1,
				'total' : 0,
			},

			'column' : [
				{'title':'姓名', 'dataIndex':'name',width:100},
				{'title':'手机号码', 'dataIndex':'phone',width:120},
				{'title':'医院名称', 'dataIndex':'hospital'},
				{'title':'创建时间', 'dataIndex':'created_at', width:180},
				{'title':'操作', 'key':'action', width:100, render:(item,record) => {
					return (
						<Space>
							<Button type="link" className="btn-in-table" onClick={() => {this.openRemoveModal(record)}}>删除</Button>
						</Space>
					)
				}},
			],

			'edit_record': {},
		}
	}
	componentDidMount(){
		this.fetch({...this.state.pagination});
	}

	getRandomuserParams = (params) => {
		return {
			pageSize: params.pageSize,
			page: params.current,
			...params,
		};
	}
	select_search = (input, option) => {
		for(let i in option.children){
			let str = option.children[i];
			if(str === ''){
				continue;
			}
			if (str.indexOf(input) >= 0){
				return true;
			}
		}
		return false;
	}

	fetch = (params) => {
		reqwest({
			url: `/api/mgm/apply`,
			method: 'GET',
			headers: {
				'Authorization': this.state.token,
			},
			data:this.getRandomuserParams(params),
			type: 'json',
		}).then(
			(data) => {
				if(data.status === 1){
					this.setState({
						'loading': false,
						'list': data.results.data,
						'pagination': {
			       			'current': params.current,
						    'pageSize': params.pageSize,
			       			'total': data.results.total,
			        	}
					})
				}else{
					message.error(data.msg);
					this.setState({
						'loading': false,
					})
				}
			},
			(err,data) => {
				if(err.response === 'Unauthorized.'){
					console.log('Token invalid');
					localStorage.removeItem('Authorization');
					this.setState({
						'redirect': '/login'
					})
					message.error('登录失效');
					return false;
				}
				message.error('Network error');
				this.setState({'loading': false})
			}
		);
	}

	// 表格发生改变时候
	handleTableChange = (pagination) => {
		this.setState({
			'loading': true,
		})
		this.fetch({
			current : pagination.current,
			pageSize: pagination.pageSize,
		});
	}


	openRemoveModal = (record) => {
		let that = this;
		Modal.confirm({
			title: '警告',
			icon: <ExclamationCircleOutlined />,
			content: '您确认删除该用户?',
			onOk() {
				reqwest({
					url: `/api/mgm/apply`,
					method: 'DELETE',
					headers: {
						'Authorization': that.state.token,
					},
					data:{'id':record['id']},
					type: 'json',
				}).then(
					(data) => {
						if(data.status === 1){
							message.success('删除成功');
							that.fetch({...that.state.pagination});
						}else{
							message.error(data.msg);
						}
					},
					(err,data) => {
						message.error('Network error');
					}
				);
			},
		});
	}

	render(){
		if(! this.state.token){
			return <Redirect to="/login"/>
		}
		if(this.state.role === 'doctor'){
			return <Redirect to="/cases"/>
		}
		if(this.state.role === 'sale'){
			return <Redirect to="/tests"/>
		}
		return (
			<div>
				<Header {...this.state}  L1="apply" />
				<div className="max-width">
					<PageHeader title="申请列表" style={{padding:0,marginTop:10}} 
						extra={[
						]}
					>
						<Table 
							bordered 
							loading={this.state.loading} 
							rowKey="id" 
							size="small" 
							columns={this.state.column} 
							dataSource={this.state.list}
							onChange={this.handleTableChange}
							pagination={{  //分页
						        total: this.state.pagination.total, //数据总数量
						        pageSize: this.state.pagination.pageSize,  //显示几条一页
						        defaultPageSize: 10, //默认显示几条一页
						        showSizeChanger: true,  //是否显示可以设置几条一页的选项
						        showTotal:  () => {return '共' + this.state.pagination.total + '条记录'; }
						    }}
						    locale={{emptyText:'No Data',}}
						/>
					</PageHeader>
				</div>
				<Footer />
			</div>
		)
	}
}